module.exports = "/_next/static/images/ManageQualityData-51ef03823b1b11426d91af14cb8d31df.webp";